<template>
    <b-card no-body>
        <b-card-header>
            <h5 class="mb-0 text-white"><b>FILTROS</b></h5>
        </b-card-header>
        <b-card-body class="pt-2">
            <b-row>

                <b-col
                    cols="12"
                    md="4"
                    class="mb-2"
                >
                    <label for="roles"><strong>ROL(ES)</strong></label>
                    <v-select
                        id="roles"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        multiple
                        v-model="formData.rolesArray"
                        :options="options.roles"
                        placeholder="Seleccione"
                        class="w-100"
                        @input="inputRolesVal()"
                    />
                </b-col>

                <b-col
                    cols="12"
                    md="4"
                    class="mb-2"
                >
                    <label for="departments"><strong>DEPARTAMENTO(S)</strong></label>
                    <v-select
                        id="departments"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        multiple
                        v-model="formData.departmentsArray"
                        :options="options.departments"
                        placeholder="Seleccione"
                        class="w-100"
                        @input="inputDepartmentsVal()"
                    />
                </b-col>

                <b-col
                    cols="12"
                    md="4"
                    class="mb-2"
                >
                    <label for="status"><strong>ESTADO</strong></label>
                    <v-select
                        id="status"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        v-model="formData.statusValue"
                        :options="options.statuses"
                        :clearable="true"
                        placeholder="Seleccione"
                        class="w-100"
                        @input="inputStatusVal()"
                    />
                </b-col>

            </b-row>

        </b-card-body>
    </b-card>
</template>

<script>

    import { ref } from '@vue/composition-api';
    import vSelect from 'vue-select';

    export default {
        components: {
            vSelect
        },
        props: {
            options: {
                type: Object,
                required: true
            }
        },
        setup(props, { emit }) {

            // REFS
            const formData = ref({
                rolesArray: [],
                departmentsArray: [],
                statusValue: null
            });

            const inputRolesVal = () => {
                if (formData.value.rolesArray)
                {
                    const array = formData.value.rolesArray.map(item => item.value);
                    emit('update:rolesFilter', array.join(','));

                    return array;
                }

                return null;
            };

            const inputDepartmentsVal = () => {
                if (formData.value.departmentsArray)
                {
                    const array = formData.value.departmentsArray.map(item => item.value);
                    emit('update:departmentsFilter', array.join(','));

                    return array;
                }

                return null;
            };

            const inputStatusVal = () => {
                const val = formData.value.statusValue ? formData.value.statusValue.value : null;
                emit('update:statusFilter', val);
            };

            return {
                // DATA
                formData,

                // METHODS
                inputRolesVal,
                inputDepartmentsVal,
                inputStatusVal
            }

        }
    }

</script>

<style lang="scss" scoped>

    .card-header {
        background-color: var(--primary);
        padding: 1rem 1.5rem;
    }

</style>

<style lang="scss">
    @import '@core/scss/vue/libs/vue-select.scss';
</style>
